import globalStyles from 'assets/stylesheets/global-styles.module.scss';
import { Breakpoints } from 'common/enums';
import { PaginationSelect } from 'common/paginator-select';
import { Spinner } from 'common/spinner';
import { classnames } from 'helpers/utils';
import { useMediaQuery } from 'hooks/use-media-query';
import { Pagination } from 'models/pagination';
import { AccountStateType } from 'pages/account/account-reducer';
import { ContributorVaultsRows } from './components/contributor-table-row';
import { ContributorRowMobile } from './components/contributor-table-row-mobile';
import styles from './contributor-table.module.scss';

type ContributorTableProps = {
  accountState: AccountStateType;
  className?: string;
  fetchingVaults: boolean;
  notifyGetMoreVaults: (page: number) => void;
};

const ContributorTable: React.FC<ContributorTableProps> = ({
  fetchingVaults,
  accountState,
  className = '',
  notifyGetMoreVaults,
}) => {
  const mobile = useMediaQuery(`(max-width: ${Breakpoints.sm}px)`);

  const { vaultsContributor, paginationContributor } = accountState;

  const thereAreMorePages = paginationContributor?.lastPage !== 1;

  const showTitle = () => (
    <p className="text__title2__gray800 mb-15">Editor vaults </p>
  );

  const showMoreVaultsButton = () => (
    <div className={styles.moreVaultsButton}>
      <PaginationSelect
        paginationInfo={paginationContributor as Pagination}
        notifyGetMoreVaults={notifyGetMoreVaults}
      />
    </div>
  );
  const contributorsRows = () =>
    mobile ? (
      <ContributorRowMobile vaults={vaultsContributor} />
    ) : (
      <ContributorVaultsRows vaults={vaultsContributor} />
    );

  const showTable = () => (
    <div className={styles.moreVaultsButton}>
      {fetchingVaults ? (
        <div className={styles.spinnerCenter}>
          <Spinner className={globalStyles.mediumSpinner} />
        </div>
      ) : (
        contributorsRows()
      )}
      {thereAreMorePages && showMoreVaultsButton()}
    </div>
  );

  const showEmptyVaults = () => (
    <div className={styles.emptyPage}>
      <div className={styles.emptyPageTexts}>
        <p
          className={classnames('text__heading5__gray700', styles.headingEmpty)}
        >
          You are not an editor in any vaults
        </p>
        <p className="text__body__regular__medium__gray700">
          Editor vaults are vaults you&apos;ve been invited to that are owned by
          another user.
        </p>
      </div>
    </div>
  );

  return (
    <div className={className}>
      {showTitle()}
      {vaultsContributor.length ? showTable() : showEmptyVaults()}
    </div>
  );
};

export { ContributorTable };
